import React from 'react';
import createHistory from 'history/createBrowserHistory';
import HelmetHeader from '../../components/HelmetHeader';

import {
  Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';

import {
  Provider
} from 'react-redux';

import {
  createAppStore
} from '../../stores/AppStore';

import {
  Home,
  ForgotPassword,
  Login,
  SignUp,
  Profile,
  ThankYou,
  AccountCreated,
  Orders,
  AboutUs
} from '../';

import NotificationList from '../../components/NotificationList/NotificationList';

import {
  Navbar,
  Footer,
  Player,
  ModalLogin
} from '../../components';

import { getProfileInformation } from '../../actions/UserActions';
import { getFavorites } from '../../actions/FavoritesActions';
import { logOutAction } from '../../actions/UserActions';

import 'bulma/css/bulma.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './app.style.css';
import './icomoon.style.css';
// I'm adding this extra font file because I don't have the selection.json file
// for the original and I don't have time to re-create it from scratch.
import '../../fonts/icomoon-2/style.css';
import 'react-select/dist/react-select.css';

const store = createAppStore();

const user = localStorage.getItem('user');
const parsedUser = JSON.parse(user);

const history = createHistory();
history.listen((_location, _action) => {
  window.scrollTo(0, 0);
});

if (user) {
  store.dispatch({ type: 'AUTHENTICATED_USER', user: parsedUser });
  store.dispatch(getProfileInformation(parsedUser.token));
  store.dispatch(getFavorites()).catch(e => {
    store.dispatch(logOutAction(history));
  });
}
export const AppRouter = () => (
  <Provider store={store}>
    <Router history={history}>
      <section className="Site">
        <div className="Site-content">
          <HelmetHeader />
          <Navbar />
          <Switch>
            <Route path="/forgot-password" component={ForgotPassword} exact />

            {/* <Route path="/orders/:orderId" component={Home} exact /> */}

            <Route path="/login" component={Login} exact />
            <Route path="/success" component={AccountCreated} exact />
            <Route path="/sign-up" component={SignUp} exact />
            {/* <Route path="/favorites" component={Favorites} exact /> */}
            <Route path="/orders" component={Orders} exact />

            <Route path="/profile" component={Profile} />

            <Route path="/thank-you" component={ThankYou} exact />
            <Route path="/about-us" component={AboutUs} exact />


            <Route path="/" component={Home} />
            <Redirect to="/" />
          </Switch>
          <ModalLogin />
          <Player />
          <NotificationList />
        </div>
        <Footer />
      </section>
    </Router>
  </Provider>
);



// WEBPACK FOOTER //
// ./src/routes/StripedRouter/StripedRouter.js